/**
 * Date format helpers — enforce dd/mm/yyyy across the app.
 * Backend continues to accept/return ISO (yyyy-mm-dd) — we only transform at the UI boundary.
 */

/**
 * Display a date value as "dd/mm/yyyy".
 * Accepts: ISO string, yyyy-mm-dd, Date object, or null/undefined.
 * Returns "-" when the value is falsy or invalid.
 */
export const formatDateDMY = (value) => {
  if (!value) return '-';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '-';
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};

/**
 * Convert any date value to ISO yyyy-mm-dd string (for <input type="date"> values
 * or API requests).
 */
export const toISODate = (value) => {
  if (!value) return '';
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

/**
 * Parse a dd/mm/yyyy string into ISO yyyy-mm-dd. Returns "" on invalid.
 */
export const parseDMYToISO = (str) => {
  if (!str) return '';
  const m = /^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{2,4})$/.exec(String(str).trim());
  if (!m) return '';
  let [, dd, mm, yyyy] = m;
  if (yyyy.length === 2) yyyy = (Number(yyyy) > 50 ? '19' : '20') + yyyy;
  const d = new Date(`${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`);
  if (Number.isNaN(d.getTime())) return '';
  return `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`;
};
